import { Fragment, useRef } from "react";
import styled from "styled-components";
import { HeaderLogo, MainImg } from "./atoms/logoImages";
import { Header, Title } from "./atoms/titles";
import {
	black,
	blue,
	darkGreen,
	green,
	lightGray,
	teal,
	white,
} from "../utils/color";
import MainTableOne from "../utils/img/table/main1.png";
import MainTableTwo from "../utils/img/table/main2.png";
import MainTableThree from "../utils/img/table/main21.png";
import General11 from "../utils/img/table/g11.png";
import General12 from "../utils/img/table/g12.png";
import General21 from "../utils/img/table/g21.png";
import General22 from "../utils/img/table/g22.png";
import General31 from "../utils/img/table/g31.png";
import General32 from "../utils/img/table/g32.png";
import Special1 from "../utils/img/table/s1.png";
import Special2 from "../utils/img/table/s2.png";
import Symposium from "../utils/img/table/symposium.png";
import logo from "../utils/img/kuf3.png";

const ProgramContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	font-family: "Noto Sans KR", sans-serif;
	width: 100%;
	padding: 15px 0 90px 0;
	box-sizing: border-box;
	background-color: ${lightGray};
`;
const TitleContainer = styled.div`
	width: 100%;
	border-bottom: 1px solid ${(props) => (props.color ? props.color : black)};
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding-bottom: 20px;
	margin-top: 40px;
`;

const ProgramTitle = styled.h2`
	font-size: 23px;
	color: ${(props) => (props.color ? props.color : black)};
	margin: 0;
	text-align: center;
`;

const ProgramVenueTitle = styled.p`
	font-size: 17px;
	color: ${(props) => (props.color ? props.color : black)};
	margin: 10px 0 0 0;
	text-align: center;
	font-weight: 400;
`;

const ProgramVenue = styled.p`
	font-size: 14px;
	color: ${(props) => (props.color ? props.color : black)};
	margin: 2px 0 0 0;
	text-align: center;
`;

const ProgramTime = styled.p`
	font-size: 15px;
	color: ${(props) => (props.color ? props.color : black)};
	margin: 10px 0 0 0;
	text-align: center;
`;
const ProgramSubtitle = styled.h3`
	font-size: ${(props) => (props.size ? props.size : 16)}px;
	text-align: center;
	color: ${(props) => (props.color ? props.color : black)};
	font-weight: ${(props) => (props.weight ? props.weight : 500)};
	padding: 0 30px;
	margin: 25px 0 ${(props) => (props.mb === 0 ? 0 : "10px")} 0;
	word-break: keep-all;
`;

const ButtonContainer = styled.div`
	position: fixed;
	bottom: 100px;
	right: 10px;
	width: 70px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Button = styled.button`
	width: 50px;
	height: 50px;
	border: 1px solid ${(props) => (props.color ? props.color : black)};
	border-radius: 50%;
	background-color: rgba(255, 255, 255, 0.8);
	color: ${(props) => (props.color ? props.color : black)};
	font-family: "Noto Sans KR", sans-serif;
	font-size: 12px;
	margin-top: 15px;
`;

function TitleModule({ title, venueTitle, venue, time, color }) {
	return (
		<Fragment>
			<ProgramTitle color={color}>{title}</ProgramTitle>
			<ProgramVenueTitle color={color}>{venueTitle}</ProgramVenueTitle>
			{venue.map((v) => {
				return (
					<ProgramVenue key={v} color={color}>
						{v}
					</ProgramVenue>
				);
			})}
			<ProgramTime color={color}>{time}</ProgramTime>
		</Fragment>
	);
}

export default function Programs() {
	const mainRef = useRef();
	const sessionRef = useRef();
	const specialRef = useRef();
	const symposiumRef = useRef();

	const handleClick = (component) => {
		component.current.scrollIntoView({ behavior: "smooth" });
	};

	return (
		<Fragment>
			<Header>
				<HeaderLogo src={logo} ref={mainRef} />
			</Header>
			<ProgramContainer>
				<Title color={white}>프로그램</Title>
				<TitleContainer id='main-session' color={blue}>
					<TitleModule
						color={blue}
						title='메인세션'
						venueTitle='한국프레스센터'
						venue={["국제회의장 (20층)"]}
						time='10월 20일 09:00 ~ 18:00'
					/>
				</TitleContainer>
				<ProgramSubtitle color={blue}>
					메인세션1:
					<br />
					지속가능한 미래를 위한 도시의 전환
				</ProgramSubtitle>
				<MainImg src={MainTableOne} alt='메인세션1 시간표' />
				<ProgramSubtitle color={blue}>
					메인세션2-1:
					<br />
					모두를 위한 도시의 전환 : 더 나은 미래를 만드는 정의로운 전환
				</ProgramSubtitle>
				<MainImg src={MainTableTwo} alt='메인세션2-1 시간표' />
				<ProgramSubtitle color={blue}>
					메인세션2-2:
					<br />
					모두에 의한 도시의 전환 : 누구도 소외되지 않는 사람 중심의 전환
				</ProgramSubtitle>
				<MainImg src={MainTableThree} alt='메인세션2-2 시간표' />
				<TitleContainer ref={sessionRef} color={darkGreen}>
					<TitleModule
						color={darkGreen}
						title='일반세션'
						venueTitle='한국프레스센터'
						venue={[
							"프레스클럽 (20층)",
							"기자회견장 (19층)",
							"외신기자클럽 (18층)",
						]}
						time='10월 20일(목) 13:30 ~ 17:00'
					/>
				</TitleContainer>
				<ProgramSubtitle color={darkGreen} mb={0}>
					일반세션1:
					<br />
					지속가능한 미래를 위한 도시의 변화
				</ProgramSubtitle>
				<ProgramVenue color={darkGreen}>
					한국프레스센터 프레스클럽 (20층)
				</ProgramVenue>
				<ProgramSubtitle color={darkGreen} weight={500} size={15}>
					일반세션1-1:
					<br />
					도시의 변화에 따른 삶과 일자리 혁신
					<br />
					(부제: 지역주도 성공창업도시 구축을 위한 사례 연구)
				</ProgramSubtitle>
				<MainImg src={General11} alt='일반세션1-1 시간표' />
				<ProgramSubtitle color={darkGreen} weight={500} size={15}>
					일반세션1-2:
					<br />
					지속가능한 생산과 소비 -
					<br />
					스마트도시의 서비스 전환
				</ProgramSubtitle>
				<MainImg src={General12} alt='일반세션1-2 시간표' />
				<ProgramSubtitle color={darkGreen} mb={0}>
					일반세션2:
					<br />
					포용적이고 안전하며 회복탄력적인
					<br /> 지속가능한 도시
				</ProgramSubtitle>
				<ProgramVenue color={darkGreen}>
					한국프레스센터 기자회견장 (19층)
				</ProgramVenue>
				<ProgramSubtitle color={darkGreen} weight={500} size={15}>
					일반세션2-1:
					<br />
					새로운 도시계획을 위한 제도적·정책적 과제
				</ProgramSubtitle>
				<MainImg src={General21} alt='일반세션2-1 시간표' />
				<ProgramSubtitle color={darkGreen} weight={500} size={15}>
					일반세션2-2:
					<br />
					도시 개발의 변화 -
					<br />
					기존 도시 개발의 한계와 새로운 도심복합개발의 방향
				</ProgramSubtitle>
				<MainImg src={General22} alt='일반세션2-2 시간표' />
				<ProgramSubtitle color={darkGreen} mb={0}>
					일반세션3:
					<br />
					미래 도시를 움직이는 새로운 힘
				</ProgramSubtitle>
				<ProgramVenue color={darkGreen}>
					한국프레스센터­ 외신기자클럽 (18층)
				</ProgramVenue>
				<ProgramSubtitle color={darkGreen} weight={500} size={15}>
					일반세션3-1:
					<br />
					도시교통체계의 전환과 새로운 모빌리티
				</ProgramSubtitle>
				<MainImg src={General31} alt='일반세션3-1 시간표' />
				<ProgramSubtitle color={darkGreen} weight={500} size={15}>
					일반세션3-2:
					<br />
					공정한 에너지 전환과 수소경제의 가능성
				</ProgramSubtitle>
				<MainImg src={General32} alt='일반세션3-2 시간표' />
				<TitleContainer ref={specialRef} color={teal}>
					<ProgramTitle color={teal}>특별세션</ProgramTitle>
					<ProgramVenueTitle color={teal}>한국프레스센터</ProgramVenueTitle>
					<ProgramVenue color={teal}>매화홀 (19층)</ProgramVenue>
					<ProgramTime color={teal}>10월 20일(목) 13:30 ~ 17:00</ProgramTime>
				</TitleContainer>
				<ProgramSubtitle color={teal}>
					특별세션1:
					<br />
					도시 주거의 미래 –
					<br />
					주거안전 취약계층의 주거권 확보
					<br />
					(서울특별시 공동주관)
				</ProgramSubtitle>
				<MainImg src={Special1} alt='특별세션1 시간표' />
				<ProgramSubtitle color={teal}>
					특별세션2:
					<br />
					지자체, 주민과 함께 하는 1기 신도시를 통한,
					<br />
					도심의 발전 방안
					<br />
					(경기도 공동주관)
				</ProgramSubtitle>
				<MainImg src={Special2} alt='특별세션2 시간표' />
				<TitleContainer ref={symposiumRef} color={green}>
					<TitleModule
						color={green}
						title='학술대회'
						venueTitle='한국프레스센터'
						venue={[
							"국제회의장 (20층)",
							"프레스클럽 (20층)",
							"매화홀 (19층)",
							"외신기자클럽 (18층)",
						]}
						time='10월 19일(수) 10:00 ~ 16:30'
					/>
				</TitleContainer>
				<ProgramSubtitle color={blue}></ProgramSubtitle>
				<MainImg src={Symposium} alt='학술대회 시간표' />
			</ProgramContainer>
			<ButtonContainer>
				<Button color={blue} onClick={(e) => handleClick(mainRef)}>
					메인
					<br />
					세션
				</Button>
				<Button color={darkGreen} onClick={(e) => handleClick(sessionRef)}>
					일반
					<br />
					세션
				</Button>
				<Button color={teal} onClick={(e) => handleClick(specialRef)}>
					특별
					<br />
					세션
				</Button>
				<Button color={green} onClick={(e) => handleClick(symposiumRef)}>
					학술
					<br />
					대회
				</Button>
			</ButtonContainer>
		</Fragment>
	);
}
